<template>
    <div id="userRoles" :switchLanguage="switchLanguage">
            <div style="position: relative;width: 900px;margin: auto;">
              <div class="newAddBox">
                <button class="newAdd"
                 @click="addUserClick('post', {
                    title: `${$t('userRoles.add.dialog.title.addUser')}`,
                    email: `${$t('userRoles.common.dialog.lable.email')}`,
                    role: `${$t('userRoles.common.dialog.lable.role')}`,
                    type: `${$t('userRoles.common.dialog.lable.permissions')}`,
                    handle: `${$t('userRoles.add.dialog.button.save')}`,
                    flag: '0'})">
                    <span>{{ $t('userRoles.button.new') }}</span>
                </button>
                <span class="newAddLine"></span>
              </div>
            </div>
        <el-main>

            <div class="headerFilterClass">
                <div class="_div">
                    <el-input
                        v-model="search"
                        size= "mini"
                        class="_input"
                        :placeholder="$t('userRoles.header.searchInput.placeholder')"
                        />
                    <i class="_sprite_class" @click="searchFn(search)"></i>
                </div>
                <div @click="filterShowFn(typeFlag)" style="display:inline-block;margin-left:45px;cursor: pointer;">
                    <i class="filterShowClass"></i>
                    <span style="vertical-align: middle;">{{ $t('userRoles.header.show.filter') }}</span>
                </div>
                <div class="allTypeDiv">
                    <div
                    :rolesDomClick="'rolesDomClick'"
                    class="allTypeChildDiv"
                    @click="typeStateFunc(true)"
                    :class="{ typeBack: $store.state.globalSelectControlState === 'rolesDomClick' }"
                    >
                    <span :rolesDomClick="'rolesDomClick'" style="display:flex;flex-grow:1;">所有角色</span>
                    <i :rolesDomClick="'rolesDomClick'" class="allTypeFilter"></i>
                    </div>
                <el-collapse-transition>
                    <ul
                    :rolesDomClick="'user'"
                    class="allTypeUl"
                    v-show="$store.state.globalSelectControlState === 'rolesDomClick'"
                    >
                    <li
                       :rolesDomClick="'user'"
                        v-for="(o, i) in contentTypeItems"
                        :key="i"
                        :class="{ stateTypeClass: typeFlag === o.code }"
                        @click="handleTypeState('0', o.code)"
                    >
                        <span :rolesDomClick="'user'" class="myProjectsStateType">{{ o.name }}</span>
                    </li>
                    </ul>
                </el-collapse-transition>
                </div>
            </div>
            <div class="_div_el_table">
                <el-table
                    ref="dataTable"
                    v-loading="loading"
                    :data="tableData2"
                    :cell-style="cellStyle"
                    :header-cell-style="headerStyle"
                    style="width: 100%">

                    <el-table-column
                    :render-header="renderHeader"
                    :label="$t('userRolse.table.header.email')"
                    width="300px;"
                    prop="date">
                    <template slot-scope="scope">
                        <div>
                            <span class="nuwaScopeClass">{{scope.row.user.email}}</span>
                        </div>
                    </template>
                    </el-table-column>

                    <el-table-column
                     :render-header="renderHeader"
                     :label="$t('userRoles.table.header.name')"
                     >
                     <template slot-scope="scope">
                         <span>{{ scope.row.user.lastName + scope.row.user.firstName}}</span>
                     </template>
                    </el-table-column>
                    <el-table-column
                     :render-header="renderHeader"
                     :label="$t('userRoles.common.dialog.lable.role')"
                    >
                    <template slot-scope="scope">
                        <div>
                            <span style="font-size: 12px;">{{ scope.row.roles[0].filter(fl => fl.langCode === switchLanguage)[0].description }}</span>
                        </div>
                    </template>
                    </el-table-column>
                   <el-table-column
                    :render-header="renderHeader"
                    :label="$t('userRoles.common.dialog.lable.permissions')">
                    <template slot-scope="scope">
                        <el-tooltip transition="el-fade-in" :popper-class="'userRolesTooltipApp'" effect="light" placement="bottom">
                            <div slot="content" :ref="'#' + scope.row.email">
                                <span v-if="scope.row.status === 'unconfirmed'" class="unconfirm" >{{ $t('userRolse.common.table.cell.unconfirm') }}</span>
                                <span v-else-if="scope.row.selectType === 'all'" class="all" style="font-size:12px;" >{{ $t('userRoles.all') }}</span>
                                <span v-else v-for="(o, i) in scope.row.apps" class="appsClass" :key="i">{{ o.title }}</span>
                            </div>
                            <div ref="reference">
                                <span v-if="scope.row.status === 'unconfirmed'" class="unconfirm" >{{ $t('userRolse.common.table.cell.unconfirm') }}</span>
                                <span v-else-if="scope.row.selectType === 'all'" class="all" style="font-size:12px;" >{{ $t('userRoles.all') }}</span>
                                <span v-else v-for="(o, i) in scope.row.apps" class="appsClass" :key="i">{{ o.title }}</span>
                            </div>
                        </el-tooltip>
                        <div class="appsClassFor">
                            <span v-if="scope.row.status === 'unconfirmed'" class="unconfirm" >{{ $t('userRolse.common.table.cell.unconfirm') }}</span>
                            <span v-else-if="scope.row.selectType === 'all'" class="all" style="font-size:12px;" >{{ $t('userRoles.all') }}</span>
                            <span v-else v-for="(o, i) in scope.row.apps" class="appsClass" :key="i">{{ o.title }}</span>
                        </div>
                    </template>
                    </el-table-column>
                    <el-table-column
                    align="center"
                    width="75px;"
                    >
                    <template slot-scope="scope">
                        <el-tooltip transition="el-fade-in" popper-class="userRolesTooltipItem" effect="light" placement="bottom">
                            <div slot="content">
                                <span @mouseleave="mouseleaveDel()" @mouseenter="mouseenterDelMdf(scope, 'mdf')" @click="userRolesHandle('put', scope, 'mdf')" :title="deleteTitle" class="userRolesToolTip modifyUserRoles" :class="!isAdmin ? 'isAdminClass' : ''">{{ $t('userRoles.table.tool.button.modify') }}</span>
                                <span @mouseleave="mouseleaveDel()" @mouseenter="mouseenterDelMdf(scope, 'del')" @click="userRolesHandle('delete', scope, 'del')" :title="deleteTitle" class="userRolesToolTip" :class="!isAdmin ? 'isAdminClass' : ''">{{ $t('userRoles.table.tool.button.del') }}</span>
                            </div>
                            <i class="setting_icon" style="vertical-align: middle;"></i>
                        </el-tooltip>
                    </template>
                    </el-table-column>
                </el-table>
            </div>

            <div :dialog="dialog">
                <el-dialog title="成员信息表单" :visible.sync="flagTag">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <h1 class="_h1_dialog_title">{{ dialog.title }}</h1>
                    <el-form-item prop="email" ref="ruleForm.email">
                        <h1 class="_h1_dialog">{{ dialog.email }}</h1>
                        <el-input v-model="ruleForm.email" class="_dialog_form_input"></el-input>
                    </el-form-item>
                    <el-form-item prop="role.displayI18n" ref="ruleForm.role">
                        <h1 class="_h1_dialog">{{ dialog.role }}</h1>
                        <el-input v-model="ruleForm.role.displayI18n" readonly="readonly" class="_dialog_form_input disableInput"></el-input>
                        <div class="triangle_border">
                            <div class="triangle_border_up" :class=" roleIndex === 0 ? 'triangle_down_no' : '' ">
                                <span @click="triangleRole('top', roleIndex)"></span>
                            </div>
                            <!-- 向下的三角形 -->
                            <div class="triangle_border_down" :class=" roleIndex + 1 === roleData.length ? 'triangle_down_no' : '' ">
                                <span @click="triangleRole('bot', roleIndex)"></span>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item prop="type.displayI18n" ref="ruleForm.type">
                        <h1 class="_h1_dialog">{{ dialog.type }}</h1>
                        <div @paste="myPaste($event)"
                        @cut="mycut($event)"
                        @keydown="keydownDiv($event)"
                        @click="clickDiv()"
                        @selectstart="selectStart($event)"
                        ref="divTest" class="imitate-input imitate-placeholder js-imitate-input" :contenteditable="contenteditable">
                            <el-tag
                            size="mini"
                            :key="i"
                            v-for="(tag, i) in dynamicTags"
                            closable
                            :disable-transitions="false"
                            @close="handleClose(tag)">
                            {{ tag.title.displayI18n }}
                            </el-tag>
                            <input
                            id="inputTest"
                            v-model="inputValue"
                            ref="saveTagInput"
                            v-if="inputVisible"
                            @keyup.enter.native="handleInputConfirm"
                            class="input-new-tag"/>
                        </div>
                        <div v-show="positionDivData.length" id="positionSearch" class="positionDiv" :style="`${toolWhat}: ${toolDivH}px;`">
                        <div
                            class="allTypeDiv"
                            >
                            <el-collapse-transition>
                            <div class="rightBoxA"
                            :style="`left:${ rightBoxALeft }px`"
                            v-show="positionDivData.length"
                            ></div>
                            </el-collapse-transition>
                            <el-collapse-transition>
                            <div class="rightBox"
                            :style="`left:${ rightBoxLeft }px`"
                            v-show="positionDivData.length"
                            ></div>
                            </el-collapse-transition>
                            <el-collapse-transition>
                            <ul
                            ref="positionDivRef"
                            class="allTypeUl"
                            v-show="positionDivData.length"
                            :style="isFlagSpanClass === 'MyProjectsList' ? 'top: 26px;' : 'top: -3px;'"
                            >
                            <li
                                v-for="(o, i) in positionDivData"
                                :key="i"
                                @click="handlePositionData('0', o.title.db)"
                            >
                                <span v-if="o.title.db === 'all'" :atr="o.title.displayI18n" class="myProjectsStateType">{{ o.title.displayI18n }}</span>
                                <span v-else :atr="o.title.displayI18n" class="myProjectsStateType">{{ o.title.displayI18n }}</span>
                            </li>
                            </ul>
                            </el-collapse-transition>
                        </div>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <div style="display:flex; margin-top:24px;">
                        <el-button @click="resetForm('ruleForm')">{{ $t('userRoles.common.dialog.button.cancle') }}</el-button>
                        <span style="display:flex;flex-grow:1;"></span>
                        <el-button type="primary" @click="submitForm('ruleForm', dialog.flag)">{{ dialog.handle }}</el-button>
                        </div>
                    </el-form-item>
                    </el-form>
                </el-dialog>
            </div>
        </el-main>
    </div>
</template>
<script>
export default {
    name: 'userRoles',
    data () {
        let checkEmail = (rule, value, callback) => {
            const mailReg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
            if (!value) {
                return callback(new Error(this.$t('enter_email')))
            }
            setTimeout(() => {
                if (mailReg.test(value)) {
                    callback()
                } else {
                    callback(new Error(this.$t('invalidEmailFormat')))
                }
            }, 100)
        }
        return {
            tableData2: [],
            search: '',
            flagTag: false,
            ruleForm: {
                email: '',
                role: '',
                type: ''
            },
            rules: {
                email: [
                    { validator: checkEmail, trigger: 'blur' }
                ]
            },
            elementItem: [
                { path: 'myAccount', msg: 'header.secondFloor.route.name.accountInfo' },
                true,
                { path: 'userRoles', msg: 'header.secondFloor.route.name.userPerm' },
                true,
                { path: 'financial', msg: 'header.secondFloor.route.name.financialManage' }
                // ,true,{ path: 'planUpgrade', msg: 'header.secondFloor.route.name.developPlan' }
            ],
            iconNavTitle: '我的账户',
            // new
            allType: false,
            contentTypeItems: [],
            typeFlag: null,
            dialog: {
                title: '邀请成员',
                email: '新增成員信箱',
                role: '角色',
                type: '应用权限',
                handle: '邀请',
                flag: '0'
            },
            roleData: [],
            roleItemArr: [],
            apps: [],
            roleIndex: 0,
            roleId: '',
            typeIndex: 0,
            loading: false,
            // tag
            dynamicTags: [],
            inputVisible: true,
            inputValue: '',
            contenteditable: true,
            innerText: '',
            toolDivH: 10,
            toolWhat: 'right',
            positionDivData: [],
            rightBoxALeft: 0,
            rightBoxLeft: 0,
            headerCellHeight: 48,
            isAdmin: false,
            deleteTitle: '',
            jsonData: []
        }
    },
    mounted () {
        // 账户 / 通知 header
        this.$store.state.iconNavHeader = this.elementItem
        this.typeItemFunc()
        // 请求所有权限用户信息
        this.userRolesData()
    },
    methods: {
        docInput () {
            let doc = document.querySelector('#inputTest')
            doc.focus()
        },
        handlePositionData (o, sel) {
            let filt = this.dynamicTags.filter(f => f.title.db === sel)[0]
            if (filt) {
                this.inputValue = ''
                this.docInput()
            } else {
                let filChoseArr = this.apps.filter(f => f.title.db === sel)
                let filChose = filChoseArr[0]
                let sleAll = this.dynamicTags.filter(f => f.title.db === 'all')[0]
                let filAll = filChoseArr.filter(f => f.title.db === 'all')[0]
                if (sleAll && filChose) {
                    this.dynamicTags = []
                } else if (filAll && filChose) {
                    this.dynamicTags = []
                    this.ruleForm.type.db = 'all'
                    filChose.title.displayI18n = this.$t('userRoles.all')
                } else {
                    this.ruleForm.type.db = 'nil'
                }
                if (filChose) {
                    this.dynamicTags.push(filChose)
                    this.inputValue = ''
                    this.docInput()
                    this.$nextTick(() => {
                        let srcEle = this.$refs.divTest
                        let eles = srcEle.childNodes
                        this.pubLocation(eles, srcEle)
                    })
                }
            }
        },
        selectStart (e) {
            e.returnValue = false
        },
        userRolesSearch (val) {
            return new Promise((resolve, reject) => {
                let appC = JSON.parse(JSON.stringify(this.apps))
                let sliceC = appC.slice(0, 1)[0]
                let appDbs = this.dynamicTags.map(m => m.title.db)
                sliceC.title.displayI18n = this.$t(`${sliceC.title.displayI18n}`)
                appC.splice(0, 1, sliceC)
                appC.forEach((fe, i) => {
                    if (appDbs.filter(f => fe.title.db === f)[0]) {
                        appC.splice(i, 1, { title: { displayI18n: '' } })
                    }
                })

                if (val) {
                    this.positionDivData = appC.filter(f => f.title.displayI18n.match(val.toLowerCase())).slice(0, 3)
                    resolve('sucess')
                }
            })
        },
        clickDiv () {
            this.docInput()
        },
        mycut (e) {
            e.returnValue = false
            return false
        },
        myPaste (e) {
            e.returnValue = false
            return false
        },
        heavyData () {
            let nodes = this.$refs.divTest.childNodes
            let texts = []
            let oldData = []
            nodes.forEach(fe => {
                if (fe.innerText) {
                    texts.push(fe)
                }
            })
            oldData = this.dynamicTags.map(m => m.title.displayI18n + ' ')
            oldData.forEach((fe, ei) => {
                texts.forEach((fc, ci) => {
                    if (fe !== fc.innerText && ei === ci) {
                        fc.firstChild.nodeValue = fe
                        fc.firstElementChild.innerText = ''
                    }
                })
            })
        },
        keydownDiv (el1) {
            // 去重
            this.heavyData()
            let code = el1.keyCode
            let targetId = el1.target.id
            let flag = false
            if (targetId === 'inputTest') {
                flag = true
            } else {
                flag = false
            }
            if (code === 8) {
                if (!flag) {
                    el1.returnValue = false
                    return
                }
            }
            let inputEle = document.querySelector('#inputTest')
            if (code === 39 || code === 37) {
                let cursorStart = inputEle.selectionStart
                if (cursorStart === 0) {
                    flag && el1.srcElement.parentElement.focus()
                    !flag && el1.srcElement.focus()
                    this.inputValue = ''
                }
            } else {
                inputEle.focus()
                if (el1.srcElement.childNodes.length === 0) {
                    el1.srcElement.parentElement.childNodes.forEach((f, i) => {
                        if (f.nodeName === '#text') {
                            el1.srcElement.parentElement.removeChild(f)
                        }
                    })
                } else {
                    el1.srcElement.childNodes.forEach((f, i) => {
                        if (f.nodeName === '#text') {
                            el1.srcElement.removeChild(f)
                        }
                    })
                }
            }
        },
        pubLocation (eles, srcEle) {
            let maps = []
            eles.forEach(m => {
                maps.push(m.clientWidth)
            })
            let margin = 10
            let borderWd = 5
            let reduceWd = maps.reduce((a, b) => a + b)
            let reduceMar = (maps.length - 2) * margin
            let lastWd = maps[maps.length - 1]
            let lastWdHf = this.$refs.positionDivRef.offsetWidth / 2
            this.rightBoxALeft = lastWdHf - borderWd
            this.rightBoxLeft = lastWdHf + 0.5 - borderWd
            if (reduceWd > 300) {
                this.toolWhat = 'right'
                this.toolDivH = lastWd + 2 + lastWdHf
            } else {
                this.toolWhat = 'left'
                this.toolDivH = reduceWd + reduceMar - lastWd + margin - lastWdHf + borderWd
            }
            maps.reduce((a, b) => a + b)
            srcEle.scrollLeft = reduceWd + lastWd
        },
        // tag
        handleClose (tag) {
            let text = tag.title.db
            this.dynamicTags.forEach((f, i) => {
                if (text === f.title.db) {
                    this.dynamicTags.splice(i, 1)
                }
            })
            this.inputValue = ''
            // 为空的时候 自动聚焦
            if (!this.dynamicTags.length) {
                this.docInput()
                let obj = { db: 'all', displayI18n: this.$t(`userRoles.all`) }
                this.dynamicTags.push({ title: obj })
            }
        },
        showInput () {
            this.inputVisible = true
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus()
            })
        },
        handleInputConfirm () {
            this.inputVisible = true
            this.inputValue = ''
        },
        // tag
        _promiseAll (arr) {
            return Promise.all(arr)
        },
        // scroll
        isScrollShowFunc (len) {
            if (len > 9) {
                this.$refs.dataTable.$el
                    .querySelector('.el-table__body-wrapper')
                    .classList.add('scrollShow')
            } else {
                this.$refs.dataTable.$el
                    .querySelector('.el-table__body-wrapper')
                    .classList.remove('scrollShow')
            }
        },
        // 渲染应用权限
        scopeShowTitle (m) {
            return this.$t('userRolse.common.table.cell.unconfirm')
        },
        // 搜索
        searchFn (val) {
            // 搜索时候让filter变成所有应用
            if (!this.search) {
                return
            }
            this.typeFlag = null
            this.userRolesData('search')
        },
        // filter role
        filterShowFn (filt) {
            !filt ? this.userRolesData() : this.userRolesData(filt)
        },
        // 这是在更换roles
        triangleRole (type, index) {
            let roleData = this.roleItemArr.map(item => {
                return {
                    roleId: item.id,
                    description: item.name,
                    code: item.code
                }
            })
            if (type === 'top' && roleData[--index]) {
                this.ruleForm.role.displayI18n = roleData[index].description
                this.ruleForm.role.db = roleData[index].code
                this.roleIndex = index
                this.roleId = roleData[index].roleId
            } else if (type === 'bot' && roleData[++index]) {
                this.ruleForm.role.displayI18n = roleData[index].description
                this.ruleForm.role.db = roleData[index].code
                this.roleIndex = index
                this.roleId = roleData[index].roleId
            }
        },
        // 移入判断是否拥有删除权限
        mouseenterDelMdf ({ row }, type) {
            let userObj = { type, doUser: row.email }
            this.tooltipFn(userObj)
                .then((res) => {
                    // console.log(res)
                })
                .then(null, (err) => {
                    // eslint-disable-next-line
                    console.log(err)
                })
        },
        mouseleaveDel () {
            this.isAdmin = true
        },
        // 判断用户是不是管理者 管理者才能执行删除 并且管理者不能删除自己
        isDeteleUserRolesFn (userArr, user, { type, doUser }) {
            let filterAdmin = userArr.filter(fl => fl.email === user)[0]
            let _isAdmin = filterAdmin.roles[0].filter(fl => fl.langCode === 'en')[0].description === 'admin'
            let isSame = user === doUser
            if (_isAdmin) {
                if (isSame) {
                    if (type === 'del') {
                        this.isAdmin = false
                        this.deleteTitle = this.$t('common.userRoles.delete.Permissions.self')
                        return false
                    } else {
                        // 这个是另外修改的一个分支 作用是保证项目至少有一个管理者
                        return this.atleastOne(userArr, user)
                    }
                } else {
                    this.isAdmin = true
                    this.deleteTitle = ''
                    return true
                }
            } else {
                this.isAdmin = false
                this.deleteTitle = this.$t('common.userRoles.delete.noPermissions')
                return false
            }
        },
        // 这是修改得func 保证项目至少拥有一个管理者
        atleastOne (userArr, user) {
            let filterRes = userArr.filter(fl => fl.roles[0].filter(fl => fl.description === 'admin')[0])
            let len = filterRes.length
            if (len >= 2) {
                this.isAdmin = true
                this.deleteTitle = ''
                return true
            } else {
                this.isAdmin = false
                this.deleteTitle = this.$t('common.userRoles.delete.Permissions.one')
                return false
            }
        },
        tooltipFn (obj) {
            return new Promise((resolve, reject) => {
                let user = localStorage.user
                if (user && this.jsonData.length) {
                    let isRes = this.isDeteleUserRolesFn(this.jsonData, user, obj)
                    if (typeof isRes === 'boolean') resolve(isRes)
                    else reject(new Error('_typeError: The return value should be of type Boolean'))
                } else {
                    reject(new Error('Please ensure that you have all authorized users and that your email account is already in the browser cache'))
                }
            })
        },
        // 修改或删除
        userRolesHandle (meth, { row }, type) {
            let user = {
                email: row.email,
                role: {
                    db: row.roles[0].filter(o => o.langCode === 'en')[0].description,
                    displayI18n: row.roles[0].filter(o => o.langCode === this.switchLanguage)[0].description
                }
            }
            let userObj = { type, doUser: row.email }
            this.tooltipFn(userObj)
                .then((res) => {
                    if (!res) {
                        this.$confirm(`${this.deleteTitle}`, this.$t('message.prompt.common.title.NWTeam'), {
                            confirmButtonText: this.$t('message.prompt.common.title.tool.ok'),
                            cancelButtonText: this.$t('userRoles.common.dialog.button.cancle'),
                            type: 'warning'
                        }).then(() => {
                            return false
                        }).catch(() => {
                            return false
                        })
                        return
                    }
                    if (meth === 'delete') {
                        this.$confirm(`${this.$t('message.prompt.common.content.del')} ${this.$t('message.prompt.common.title.continue')}`, this.$t('message.prompt.common.title.NWTeam'), {
                            confirmButtonText: this.$t('message.prompt.common.title.tool.ok'),
                            cancelButtonText: this.$t('userRoles.common.dialog.button.cancle'),
                            type: 'warning'
                        }).then(() => {
                            this.handleUrl(meth, user)
                        }).catch((err) => {
                            // eslint-disable-next-line
                            console.log(err)
                        })
                    } else {
                        let obj = {
                            title: `${this.$t('userRoles.modify.dialog.title.modifyUser')}`,
                            email: `${this.$t('userRoles.common.dialog.lable.email')}`,
                            role: `${this.$t('userRoles.common.dialog.lable.role')}`,
                            type: `${this.$t('userRoles.common.dialog.lable.permissions')}`,
                            handle: `${this.$t('userRoles.modify.dialog.button.save')}`,
                            flag: '1'
                        }
                        if (row.selectType === 'all') {
                            user.type = {
                                db: 'all',
                                displayI18n: this.$t(`userRoles.all`)
                            }
                        } else {
                            user.type = {
                                db: row.apps[0].appId,
                                displayI18n: row.apps[0].title
                            }
                        }
                        Object.assign(this.dialog, obj)
                        // 这是保证form的初始值是我们默认的
                        this.flagTag = true
                        this.$nextTick(() => {
                            this.ruleForm = user
                            this.$refs['ruleForm'] && this.$refs['ruleForm'].clearValidate()
                        })
                        this.addUserClick('put', obj)
                    }
                })
                .then(null, (err) => {
                    // eslint-disable-next-line
                    console.log(err)
                })
        },
        // handleURLtype
        handleUrl (method, { email, role }) {
            let roleIds, selectType, body
            let appIds = []
            if (method === 'post') {
                roleIds = [this.roleId]
                if (this.dynamicTags[0].title.db === 'all') {
                    selectType = 'all'
                } else {
                    selectType = 'candidate'
                    appIds = this.dynamicTags.map(m => m.title.db)
                }
                if (!appIds.length) {
                    body = { email, roleIds, selectType }
                } else {
                    body = { email, roleIds, selectType, appIds }
                }
            } else if (method === 'put') {
                roleIds = [this.roleId]
                if (this.dynamicTags[0].title.db === 'all') {
                    selectType = 'all'
                } else {
                    selectType = 'candidate'
                    appIds = this.dynamicTags.map(m => m.title.db)
                }
                if (!appIds.length) {
                    body = { email, roleIds, selectType }
                } else {
                    body = { email, roleIds, selectType, appIds }
                }
            } else {
                body = { email }
            }
            this.handleRolesData(method, body)
        },
        // list roles 这是所有权限
        listRolesData (type) {
            // 请求user信息
            let path = 'developer/role'
            return this._api
                .request('get', path)
        },
        _handleRolesData (roles) {
            // this.roleData = roles.data.data.payload
            let { email } = this.ruleForm
            // roleIndex
            this.roleItemArr.forEach((ele, ind) => {
                if (this.ruleForm.role.db === ele.code) {
                    this.roleIndex = ind
                    this.roleId = ele.id
                }
            })
            if (email) {
                let showObj
                let filtRes = this.tableData2.filter(f => f.email === email)[0]
                let flitApps = filtRes.appIds.map(m => this.apps.filter(f => f.title.db === m)[0])
                showObj = flitApps
                if (filtRes.selectType === 'all') {
                    let obj = this.apps.filter(f => f.title.db === filtRes.selectType)[0]
                    obj.title.displayI18n = this.$t('userRoles.all')
                    showObj = [obj]
                }
                this.dynamicTags = showObj
            }
        },
        // getApps
        getAppData () {
            // 请求user信息
            let path = 'developer/app'
            return this._api
                .request('get', path)
        },
        _handleAppData (apps) {
            let appData = apps.data.data.payload
            let keys = [
                {
                    key: 'title',
                    val: 'all'
                }
            ]
            this.apps = appData.map(item => {
                return {
                    title: {
                        db: item.appId,
                        displayI18n: item.projectName
                    }
                }
            })
            this.getMapping([{ title: 'all' }], keys, 'apps')
            this.apps.forEach((el, ind) => {
                if (el.title.db === this.ruleForm.type.db) {
                    this.typeIndex = ind
                    if (this.ruleForm.type.db === 'all') {
                        this.ruleForm.type.displayI18n = this.$t(`${this.apps[this.typeIndex].title.displayI18n}`)
                    } else {
                        this.ruleForm.type.displayI18n = this.apps[this.typeIndex].title.displayI18n
                    }
                }
            })
        },
        // add delete modify
        handleRolesData (method, body) {
            // 请求user信息
            let path = 'developer/user/contact/role'
            this._api
                .request(method, path, body)
                .then(res => {
                    if (res.status === 200) {
                        this.userRolesData()
                        this.flagTag = false
                    }
                })
                // .catch(err => {
                //     console.log(err)
                // })
        },
        // list权限 这是所有权限用户
        userRolesData (type) {
            this.loading = true
            // 请求user信息
            let path = 'developer/user/contact/role'
            this._api
                .request('get', path)
                .then(res => {
                    if (res.status === 200) {
                        this.jsonData = JSON.parse(JSON.stringify(res.data.data.payload))
                        this.tableData2 = res.data.data.payload
                        this.tableData2.forEach((fe, index) => {
                            if (typeof fe.user.firstName !== 'string') {
                                fe.user.firstName = ''
                            }
                            if (typeof fe.user.lastName !== 'string') {
                                fe.user.lastName = ''
                            }
                            // if (index % 2 === 0) {
                            //     fe.status = 'ok'
                            // }
                        })
                        // console.log(this.tableData2)
                        // this.$set(this, 'tableData2', res.data.data.payload)
                        // dom
                        this.domToolTipFn()
                        !type || (this.tableData2 = this.tableData2.filter(f => f.roles[0].some(fl => fl.description === type)))
                        !type && (this.typeFlag = null)
                        if (type === 'search') {
                            let dataClone = res.data.data.payload
                            let nameArr = []
                            let emaileArr = []
                            dataClone.filter(f => f.email.match(this.search.toLowerCase())).forEach(fe => {
                                emaileArr.push(fe)
                            })
                            dataClone.filter(f => (f.user.lastName + f.user.firstName).match(this.search.toLowerCase())).forEach(fe => {
                                nameArr.push(fe)
                            })
                            this.tableData2 = [].concat(nameArr, emaileArr)
                            this.tableData2 = this.uniqueArr(this.tableData2, 'email')
                        }
                        this.loading = false
                        this.isScrollShowFunc(this.tableData2.length)
                    }
                })
                // .catch(err => {
                //     console.log(err)
                // })
        },
        resetDomStyle (len) {
            // 这个函数是为了让数据变动的时候,例如搜索或者修改应用权限之后,让所有el-tooltip 和 appsClassFor这两个class元素全部重置
            this.$el.querySelector('tbody').childNodes.forEach(fe => {
                if (fe.childNodes[len - 2]) {
                    fe.childNodes[len - 2].querySelector('.el-tooltip').style.display = 'block'
                    fe.childNodes[len - 2].querySelector('.appsClassFor').style.display = 'block'
                }
            })
            Object.keys(this.$refs).forEach((fe, ind) => {
                if (fe.indexOf('#') !== -1) {
                    if (this.$refs[fe]) {
                        this.$refs[fe].childNodes.forEach(fes => { fes.style.display = 'inline-block' })
                    }
                }
            })
        },
        domToolTipFn () {
            this.$nextTick(() => {
                const len = this.$el.querySelector('tbody').childNodes[0].childNodes.length
                this.resetDomStyle(len)
                let res = []
                this.$el.querySelector('tbody').childNodes.forEach((fe, i) => {
                    // 先要判断是否拥有节点
                    if (fe.childNodes[len - 2] && fe.childNodes[len - 2].querySelector('.el-tooltip') && fe.childNodes[len - 2].querySelector('.el-tooltip').clientHeight < 60) {
                        res.push(fe.childNodes[len - 2].querySelector('.el-tooltip'))
                    } else if (fe.childNodes[len - 2]) {
                        let lens = 0
                        let _index = []
                        fe.childNodes[len - 2].querySelector('.appsClassFor').style.display = 'none'
                        fe.childNodes[len - 2].querySelector('.el-tooltip').childNodes.forEach((fes, index) => {
                            lens += fes.clientWidth + 5
                            if (lens > 155) {
                                _index.push(index)
                                lens = 0
                            }
                        })
                        // 如果数组的长度大于等于2的话 说明需要出现tooltip
                        if (_index.length >= 2) {
                            let b = []
                            fe.childNodes[len - 2].querySelector('.el-tooltip').childNodes.forEach((fes, i) => {
                                if (i <= _index[1]) {
                                    if (i === _index[1]) {
                                        fes.innerText = '......'
                                        fes.classList.add('appsClassSplit')
                                    }
                                } else {
                                    b.push(fes)
                                }
                            })
                            Object.keys(this.$refs).forEach((fes, ind) => {
                                if (fes.indexOf('#') !== -1) {
                                    if (this.$refs[fes]) {
                                        this.$refs[fes].childNodes.forEach((fesm, indx) => {
                                            if (indx < _index[1]) {
                                                fesm.style.display = 'none'
                                            }
                                        })
                                    }
                                }
                            })
                            // b.forEach(fes => fe.childNodes[len - 2].querySelector('.el-tooltip').removeChild(fes))
                            b.forEach(fes => {
                                fes.style.display = 'none'
                            })
                        } else {
                            fe.childNodes[len - 2].querySelector('.appsClassFor').style.display = 'block'
                            fe.childNodes[len - 2].querySelector('.el-tooltip').style.display = 'none'
                        }
                    }
                })
                // 这是不用出现tooltip的情况, 所以隐藏class为'.tooltip'这个元素
                res.forEach(fe => {
                    fe.style.display = 'none'
                })
            })
        },
        uniqueArr (arr, key) {
            let hash = {}
            return arr.reduce((item, next) => {
                if (!hash[next[key]]) {
                    hash[next[key]] = true
                    item.push(next)
                }
                return item
            }, [])
        },
        // 多语言
        getMapping (data, keys, type) {
            keys.forEach((ele, ind) => {
                let clone = this._languageTransfer(
                    data.map(i => {
                        if (!i[ele['key']]) {
                            i[ele['key']] = ele['val']
                        }
                        return i[ele['key']]
                    })
                )
                if (type === 'tableData2') {
                    this.tableData2 = this.tableData2.map((item, index) => {
                        item.roles[0][ele['key']] = clone[index]
                        return item
                    })
                } else if (type === 'roleData') {
                    this.roleData = this.roleData.map((item, index) => {
                        item.i18n[0][ele['key']] = clone[index]
                        return item
                    })
                } else {
                    this.apps.unshift({ title: clone[0] })
                }
            })
        },
        handleTypeState (type, data) {
            this.typeFlag = data
        },
        // 初始化角色下拉表单
        typeItemFunc () {
            this.listRolesData()
                .then(res => {
                    this.roleData = res.data.data.payload
                })
                // .catch(err => {
                //     console.log(err)
                // })
        },
        // 这是roles的i18n
        initRolesData (lang, rolesDate) {
            let filtersD = rolesDate.map((m, mi) => {
                return {
                    id: m.roleId,
                    code: m.i18n.filter((ms, msi) => ms.langCode === 'en')[0].description,
                    name: m.i18n.filter((ms, msi) => ms.langCode === lang)[0].description
                }
            })
            this.roleItemArr = JSON.parse(JSON.stringify(filtersD))
            filtersD.unshift({ id: null, code: null, name: '所有角色' })
            this.contentTypeItems = filtersD
        },
        typeStateFunc (type) {
            if (type) {
                this.allType = !this.allType
            } else {
                this.allState = !this.allState
            }
        },
        // 自定义渲染
        renderHeader (h, { column, $index }) {
            return (
                <div style="padding:0;display:inline;">
                    <span style="marginRight:20px; font-size: 14px;color:#333333;">
                        {column.label}
                    </span>
                </div>
            )
        },
        // 这是修改或者增加的dialog的数据更换
        addUserClick (type, obj) {
            if (obj.flag === '0') {
                this.flagTag = true
                Object.assign(this.dialog, obj)
                this.$refs['ruleForm'] && this.$refs['ruleForm'].clearValidate()
                let objAs = { db: 'all', displayI18n: this.$t(`userRoles.all`) }
                this.ruleForm = {
                    email: '',
                    // role: 'admin',
                    role: {
                        db: 'admin',
                        displayI18n: this.$t(`userRoles.admin`)
                    },
                    type: objAs
                }
                // 增加的rowIndex = 0
                this.roleIndex = 0
                // 清空dynamicTags
                this.dynamicTags = []
                this.dynamicTags.push({ title: objAs })
            }
            // 打开dialog之前先请求所有应用 和所有角色
            const { getAppData, listRolesData } = this
            const { _handleAppData, _handleRolesData } = this
            this._promiseAll([getAppData(), listRolesData()])
                .then(res => {
                    // 表单打开之前清楚表单验证
                    res.forEach((f, i) => {
                        !i && _handleAppData(f)
                        i && _handleRolesData(f)
                    })
                })
                .then(null, err => {
                    // console.log(err)
                    err && (this.flagTag = false)
                })
        },
        // 提交dialog 修改或者增加
        submitForm (formName, type) {
            this.flagTag = true
            this.$refs[formName].validate(valid => {
                if (valid) {
                    let flag = this.tableData2.some(f => f.email === this.ruleForm.email)
                    if (type === '0' && flag) {
                        this.$confirm(`${this.$t('message.prompt.common.content.userRoles.modifybefore')} ${this.$t('message.prompt.common.content.userRoles.modifyafter')}`, this.$t('message.prompt.common.title.NWTeam'), {
                            confirmButtonText: this.$t('message.prompt.common.title.tool.ok'),
                            cancelButtonText: this.$t('userRoles.common.dialog.button.cancle'),
                            type: 'warning'
                        }).then(() => {
                            this.handleUrl('post', this.ruleForm)
                        }).catch(() => {
                            return false
                        })
                    } else if (type === '1' && !flag) {
                        this.$confirm(`${this.$t('message.prompt.common.content.userRoles.addbefore')} ${this.$t('message.prompt.common.content.userRoles.addafter')}`, this.$t('message.prompt.common.title.NWTeam'), {
                            confirmButtonText: this.$t('message.prompt.common.title.tool.ok'),
                            cancelButtonText: this.$t('userRoles.common.dialog.button.cancle'),
                            type: 'warning'
                        }).then(() => {
                            this.handleUrl('put', this.ruleForm)
                        }).catch(() => {
                            return false
                        })
                    } else {
                        type === '0' ? this.handleUrl('post', this.ruleForm) : this.handleUrl('put', this.ruleForm)
                    }
                } else {
                    return false
                }
            })
        },
        // 重置dialog
        resetForm (formName) {
            this.flagTag = false
            this.$refs[formName].resetFields()
        },
        cellStyle ({ row, column, rowIndex, columnIndex }) {
            let str = `padding-left:17px!important;color:#333333;font-size: 14px;`
            return str
        },
        headerStyle ({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0) {
                return `
          padding-left:18px!important;height:${this.headerCellHeight}px;
          `
            } else if (columnIndex === 1) {
                return `
          padding-left:17px!important;height:${this.headerCellHeight}px;
          `
            } else {
                return `
          padding-left:15px!important;height:${this.headerCellHeight}px;
          `
            }
        }
    },
    watch: {
        search () {
            this.search || this.userRolesData()
            this.searchFn(this.search)
            return this.search
        },
        dynamicTags () {
            return this.dynamicTags
        },
        inputValue () {
            if (this.inputValue) {
                this.userRolesSearch(this.inputValue)
                    .then(res => {
                        let doc = this.$refs.divTest
                        let nodes = doc.childNodes
                        this.pubLocation(nodes, doc)
                    })
            } else {
                this.positionDivData = []
            }
            return this.inputValue
        }
    },
    computed: {
        isFlagSpanClass () {
            this.typeFlag = null
            this.allType = false
            return this.$store.state.isFlagSpanClass
        },
        switchLanguage () {
            this.initRolesData(this.$store.state.switchLanguage, this.roleData)
            return this.$store.state.switchLanguage
        }
    },
    beforeUpdate () {
        if (!this.flagTag && this.$refs['ruleForm']) {
            this.$refs['ruleForm'].resetFields()
            this.inputValue = ''
        }
    }
}
</script>
<style scoped>
h1 {
  margin: 0px;
}
#userRoles{
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.8px;
    color: #333333;
}
ul{
    margin: 0px;
}
li{
    list-style: none;
}
.isAdminClass{
    cursor: not-allowed;
}
.positionDiv{
    height: 50px;
    position: absolute;
    z-index: 1;
    bottom: -55px;
}
.appsClass{
    width: 62px;
    margin-right: 5px;
    font-size: 12px;
    display: inline-block;
    height: 18px;
    border-radius: 4px;
    background-color: rgba(51, 51, 51, 0.1);
    padding: 0px 5px;
    line-height: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.appsClassSplit{
    width: 32px;
    text-align: center;
}
.unconfirm{
    display: inline-block;
    font-size: 12px;
    width: 85px;
    height: 25px;
    border-radius: 4px;
    background-color: rgba(0, 181, 226, 0.1);
    color: #00b5e2;
    border: 1px solid #00b5e2;
    box-sizing: border-box;
    line-height: 25px;
    text-align: center;
}
/* 三角形 */
#positionSearch .allTypeDiv {
    margin-left: -2px;
    height: 0px;
}
#positionSearch .allTypeChildDiv {
    padding: 1px 9px;
    border-radius: 4px;
    line-height: 24px;
    display: flex;
    width: 100%;
    box-sizing: border-box;
    border: 2px solid #ffffff;
}
#positionSearch .rightBoxA {
    width: 0;
    height: 0;
    border-width: 0 6px 6px;
    border-style: solid;
    border-color: transparent transparent rgba(51, 51, 51, 0.2);
    margin: 0px auto;
    position: absolute;
    top: -8px;
    left: 48%;
    transition: .3s;
}
#positionSearch .rightBox {
    width: 0;
    height: 0;
    border-width: 0 5px 5px;
    border-style: solid;
    border-color: transparent transparent #fff;
    margin: 0px auto;
    top: -7px;
    position: absolute;
    left: 49%;
    z-index: 3;
    transition: .3s;
}
#positionSearch .allTypeUl li {
    font-family: sans-serif;
    font-size: 12px;
    font-weight: 300;
    letter-spacing: 0.7px;
    color: #333333;
}
#positionSearch .allTypeUl li:hover {
    background: rgba(0, 224, 218, 0.1);
}

.allTypeUl li:active > span {
   color: #00b5e2;
   font-weight: 500;
   opacity: 1;
   box-sizing: border-box;
}
.allTypeUl li > span::after{
  display: block;
  content: attr(atr);
  font-weight: 500;
  visibility: hidden;
  height: 1px;
  color: transparent;
  margin-bottom: -1px;
  overflow: hidden;
}
#positionSearch .allTypeUl {
    padding: 6px 0px 6px 0px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.06);
    background-color: #ffffff;
    border: 1px solid rgba(51, 51, 51, 0.3);
    border-radius: 4px;
    position: absolute;
    top: 39px;
    cursor: default;
}
/* 三角形 */
.triangle_down_no{
    pointer-events: none;
    opacity: .5;
}
.triangle_border{
    width: 30px;
    height: 38px;
    position: absolute;
    right: 0px;
    bottom: 0px;
}
/*向上*/
.triangle_border_up{
    position: absolute;
    bottom: 25px;
    right: 25px;
}
.triangle_border_up span{
    display:block;
    width:0;
    height:0;
    border-width:0 5px 5px;
    border-style:solid;
    border-color:transparent transparent rgba(51, 51, 51, 0.5);/*透明 透明  黄*/
    position:absolute;
    top:0px;
    left:0px;
}
.triangle_border_up span:active{
    border-color:transparent transparent #00b5e2;/*透明 透明  黄*/
    opacity: 1!important;
}
.triangle_border_up span:hover{
   opacity: .5;
}
.triangle_border_down span:hover{
   opacity: .5;
}
.triangle_border_down span:active{
    border-color: #00b5e2 transparent transparent;/*透明 透明  黄*/
    opacity: 1!important;
}
/*向下*/
.triangle_border_down{
    position: absolute;
    right: 25px;
    bottom: 18px;
}
.triangle_border_down span{
    display:block;
    width:0;
    height:0;
    border-width:5px 5px 0;
    border-style:solid;
    border-color:rgba(51, 51, 51, 0.5) transparent transparent;/*黄 透明 透明 */
    position:absolute;
    top:0px;
    left:0px;
}
/* new */
.modifyUserRoles{
    color: #00b5e2!important;
    font-weight: 500!important;
}
.userRolesToolTip{
    display: block;
    height: 28px;
    font-size: 12px;
    letter-spacing: 0.7px;
    color: #333333;
    line-height: 28px;
    font-weight: 300;
    padding: 0px 10px;
}
.userRolesToolTip:hover{
    background-color: rgba(0, 224, 218, 0.05)
}
.nuwaScopeClass{
    font-size: 14px;
    /* cursor:pointer; */
}
.headerFilterClass{
    font-size: 12px;
    font-weight: 300;
    letter-spacing: 0.7px;
    width:896px;
    margin:auto;
    line-height: 30px;
    margin-bottom: 20px;
    display:flex;
}
.stateTypeClass {
    font-size: 12px;
    font-weight: 500 !important;
    letter-spacing: 0.7px;
    color: #00b5e2 !important;
}
.typeBack {
    border-color: rgba(0, 224, 218, 0.5) !important;
}
.headerFilterClass .allTypeDiv {
    margin-left: 18px;
    height: 30px;
    position: relative;
    cursor: pointer;
    width: 166px;
    box-sizing: border-box;
    line-height: 28px;
}
.allTypeChildDiv:hover {
    background-color: rgba(51, 51, 51, 0.05);
}
.allTypeChildDiv:active{
   background-color: rgba(0, 224, 218, 0.1);
}
.allTypeChildDiv{
    padding: 0px 10px;
    display: flex;
    border: 2px solid #ffffff;
    border-radius: 4px;
}
.rightBoxA {
    width: 0;
    height: 0;
    border-width: 0 6px 6px;
    border-style: solid;
    border-color: transparent transparent rgba(51, 51, 51, 0.2);
    margin: 0px auto;
    position: absolute;
    top: 35px;
    left: 48%;
    transition: .3s;
    /* display: none; */
}
.rightBox {
    width: 0;
    height: 0;
    border-width: 0 5px 5px;
    border-style: solid;
    border-color: transparent transparent #fff;
    margin: 0px auto;
    top: 37px;
    position: absolute;
    left: 48.5%;
    z-index: 3;
    transition: .3s;
    /* display: none; */
}
.allTypeUl li {
    font-size: 12px;
    font-weight: 300;
    letter-spacing: 0.7px;
    list-style: none;
    line-height: normal;
}
.allTypeUl li:hover {
    background: rgba(0, 224, 218, 0.1);
}
.headerFilterClass .allTypeUl {
    padding: 6px 0px 6px 0px;
    width: 162px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.06);
    background-color: #ffffff;
    border: 1px solid rgba(51, 51, 51, 0.3);
    border-radius: 4px;
    z-index: 1;
    position: absolute;
    top: 29px;
    cursor: default;
    left: 1px;
}
.myProjectsStateType {
    display: inline-block;
    padding: 0px 11px;
    width: 100%;
    margin: 6px 0px;
    box-sizing: border-box;
    white-space: nowrap;
}
.myProjectsStateType:hover {
    margin-top: 4px;
    margin-bottom: 8px;
    opacity: .5;
}
/* new */
._sprite_class {
  display: inline-block;
  width: 14px;
  height: 13px;
  background-image: url("../../assets/img/header/filter_search_icon.png");
  position: absolute;
  left: 9px;
  top: 9px;
  cursor: pointer;
  text-align: center;
  background-size: 100%;
}
.allTypeFilter{
  display: inline-block;
  width: 15.5px;
  height: 10.1px;
  background-image: url("../../assets/img/header/select_bottom_icon.png");
  vertical-align: middle;
  cursor: pointer;
  text-align: center;
  background-size: 100%;
  margin-top: 9px;
}
.filterShowClass{
  display: inline-block;
  width: 13px;
  height: 12px;
  background-image: url("../../assets/img/header/filter_show_icon.png");
  vertical-align: middle;
  text-align: center;
  background-size: 100%;
  margin-right: 5px;
}
#userRoles{
  font-weight: 300;
}
.setting_icon{
  display: inline-block;
  width: 20px;
  height: 20px;
  background-image: url("../../assets/img/header/user_seeting_icon.png");
  text-align: center;
  background-size: 100%;
}
.newAdd {
  /* width: 166px; */
  width: 75px;
  height: 50px;
  outline: none;
  border: 1px solid;
  border-radius: 10px;
  background-color: #00b5e2;
  font-family: sans-serif;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 1.1px;
  text-align: center;
  color: #ffffff;
  position: absolute;
  top: 30px;
  right: 0px;
  cursor: pointer;
  line-height: 47px;
}
.newAdd > span{
    display: block;
    width: 100%;
    height: 100%;
}
.newAdd > span:hover{
    display: block;
    width: 100%;
    height: 100%;
    margin-top: -2px;
}
.newAddBox {
  width: 166px;
}
.newAddLine {
  /* width: 146px; */
  width: 58px;
  height: 2px;
  background: rgba(51, 51, 51, 0.3);
  position: absolute;
  top: 77.2px;
  right: 8px;
}
._input {
  border-radius: 3px;
  outline: none !important;
}
._div {
  display: inline-block;
  position: relative;
}
._div_el_table {
  width: 896px;
  margin: auto;
  box-sizing: border-box;
  margin-bottom: 190px;
  border-bottom: none;
}
._h1_dialog {
  font-size: 18px;
  margin-bottom: 8px;
  width: 348px;
  height: 20px;
  line-height: 20px;
  font-family: sans-serif;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.8px;
}
._h1_dialog_title {
  width: 348px;
  height: 29px;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 1.1px;
  text-align: center;
  margin-bottom: 25px;
}
._dialog_form_input {
  width: 348px;
  height: 38px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(51, 51, 51, 0.06);
  background-color: #ffffff;
}
</style>

<style>
.el-tooltip__popper.is-light{
    font-family: sans-serif;
}
#userRoles .imitate-input{
    width: 330px;
    height: -7px;
    border: 1px solid rgba(51, 51, 51, 0.5);
    border-radius: 8px;
    padding: 9px 10px;
    size: 16px;
    line-height: 16px;
    outline: none;
    color: #000;
    white-space: nowrap;
    overflow-x: scroll;
    word-break: normal;
}
/* 清除左右滚动条 */
#userRoles .imitate-input::-webkit-scrollbar{
    display: none;
}
#userRoles .imitate-input:empty:before{
    content: attr(placeholder);
    color: #999;
}
#userRoles .imitate-input:focus:before{
    content: none;
}

#userRoles .el-tag + .el-tag {
    margin-left: 10px;
  }
#userRoles .el-tag{
    background-color: rgba(51, 51, 51, 0.1);
    border: none;
    color: #333;
}
#userRoles .el-tag .el-icon-close {
    border-radius: 50%;
    text-align: center;
    position: relative;
    cursor: pointer;
    font-size: 12px;
    height: 16px;
    width: 16px;
    line-height: 16px;
    top: -1px;
    right: -5px;
    color: #fff;
    background: rgba(51, 51, 51, 0.5);
}
#userRoles .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}
#userRoles .input-new-tag {
    width: 78px;
    height: 18px;
    vertical-align: bottom;
    border: none;
    outline: none;
    padding-left: 1px;
}

.scrollShow {
    overflow: scroll!important;
    overflow-x: hidden!important;
    height: 360px;
}
.userRolesTooltipItem{
    padding: 5px 0px 0px 0px!important;
    border: 1px solid #d6d6d6!important;
    text-align: left;
}
.userRolesTooltipApp{
    padding: 0px 5px!important;
    border: 1px solid #d6d6d6!important;
    padding-top: 6px!important;
    /* text-align: center; */
    /* margin-left: -50px; */
    width: 155px;
    line-height: 23px!important;
}
.userRolesTooltipAppS{
    width: 110px;
}
/*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
#userRoles ::-webkit-scrollbar {
    width: 8px; /*对垂直流动条有效*/
    height: 10px; /*对水平流动条有效*/
}
/*定义滚动条的轨道颜色、内阴影及圆角*/
#userRoles ::-webkit-scrollbar-track {
    /* -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); */
    background-color: rgba(51, 51, 51, 0.2);
    border-radius: 3px;
}
/*定义滑块颜色、内阴影及圆角*/
#userRoles ::-webkit-scrollbar-thumb {
    border-radius: 7px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: rgba(255, 255, 255, 0.8);
}
#userRoles .el-button--primary:active{
    opacity: .5;
}
#userRoles .el-button--default:active{
    opacity: .5;
}
.userRolesTooltipItem .popper__arrow {
    border-top-color: #d6d6d6!important;
    border-bottom-color: #d6d6d6!important;
}
.userRolesTooltipApp .popper__arrow {
    border-top-color: #d6d6d6!important;
    border-bottom-color: #d6d6d6!important;
    left: 45%!important;
}
#userRoles .el-table__body tr:last-child > td{
    border-bottom: none!important;
}
#userRoles .el-table--fit{
    border: 1px solid rgba(51, 51, 51, 0.2);
    border-radius: 8px;
}
#userRoles .el-input--mini .el-input__inner{
  width: 166px;
  padding-left: 29px;
  line-height: 30px;
  height: 30px;
  border-color: rgba(51, 51, 51, 0.2);
  opacity: 0.8;
  letter-spacing: 0.7px;
  transition: .2s;
}
#userRoles .el-input__inner:focus {
  border: 2px solid rgba(0, 224, 218, 0.5) !important;
}
#userRoles .el-table th,
.el-table td {
  padding: 0px;
}
#userRoles .el-button {
  padding: 7px 20px;
  width: 164px;
  height: 28px;
  border-radius: 4px;
}
#userRoles .el-dropdown {
  left: 27px;
}
#userRoles .el-dropdown-link {
  cursor: pointer;
}
#userRoles .el-main {
  padding: 0px;
  padding-top: 85px;
}
#userRoles .el-table th.is-leaf,
.el-table td {
}
#userRoles .el-table--enable-row-transition .el-table__body td {
  padding-left: 30px;
  height: 90px;
}

#userRoles .el-dialog__header {
  display: none;
}
#userRoles .el-form-item__content {
  margin-left: 0px !important;
  position: relative;
}
#userRoles .el-form-item__error {
  margin-left: 30px;
}
#userRoles .el-dialog {
  padding: 37px 93px 42px 93px;
  width: 533px;
  box-sizing: border-box;
  border-radius: 8px;
}
#userRoles .el-table .cell {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
#userRoles .el-form-item {
  margin-bottom: 18px;
}
#userRoles .el-dialog__body {
  padding: 0px;
  color: #333333;
}

#userRoles .el-button--primary {
   color: #fff;
   background-color: #00b5e2;
   border-color: #00b5e2;
}
#userRoles .el-button--default {
   color: #333333;
   background-color: #fff;
   border-color: rgba(51, 51, 51, 0.3);
}
#userRoles .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: rgba(0, 224, 218, 0.05) !important;
}
#userRoles .el-form-item.is-success .el-input__inner, .el-form-item.is-success .el-input__inner:focus, .el-form-item.is-success .el-textarea__inner, .el-form-item.is-success .el-textarea__inner:focus{
  border-color: rgba(51, 51, 51, 0.5)!important;
}
#userRoles ._dialog_form_input .el-input__inner{
    border: 1px solid rgba(51, 51, 51, 0.5);
    border-radius: 8px;
    font-family: sans-serif;
    font-size: 14px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.8px;
    color: #333333;
}
#userRoles ._dialog_form_input > .el-input__inner:focus {
    border: 1px solid rgba(51, 51, 51, 0.5)!important;
}
#userRoles .el-form-item.is-error .el-input__inner{
    border-color: #f56c6c;
}
</style>
